module.exports = __webpack_public_path__ + "aca13f5ba3644e7c21bde870e91f3ccb.png";